import { useState, useEffect } from 'react';
import Axios from 'axios';

const useAjax = url => {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Set up a cancellation source
    let source = Axios.CancelToken.source();

    const loadData = async () => {
      try {
        const response = await Axios.get(url, {
          // Assign the source.token to this request
          cancelToken: source.token
        });
        setData(response.data);
      } catch (error) {
        // Is this error because we cancelled it ourselves?
        if (Axios.isCancel(error)) {
          // console.log(`call for ${url} was cancelled`);
        } else {
          throw error;
        }
      }
    };
    loadData();

    return () => {
      // Let's cancel the request on effect cleanup
      source.cancel();
    };
  }, [url]);

  return data;
};

export default useAjax;
